<section class="scan-batch-success-container">
  <header class="header">
    <div role="button" class="close-btn-container">
      <img mat-dialog-close src="/assets/images/scan/close_icon.svg" alt="" />
    </div>
    <div class="success-img">
      <img src="/assets/images/scan/success_icon.svg" alt="" />
    </div>
    <div class="header__title" mat-dialog-title>
      <div>Batch {{ batch.name }}</div>
      <div>Scanning Complete</div>
    </div>
  </header>
  <div class="scan-batch-success-content" mat-dialog-content>
    <div class="scanned-orders-count">{{ batch.orders.length }}/{{ batch.orders.length }}</div>
  </div>
  <div class="scan-batch-success-actions" mat-dialog-actions>
    <button class="scan-batch-success-actions__btn" mat-flat-button color="primary" mat-dialog-close>DONE</button>
  </div>
</section>
